<template>
  <vue-phone-number-input
    v-on:update="phoneValidation"
    default-country-code="SE"
    :dark="darkmode"
    :only-countries="['SE']"
    v-model="number"
  />
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PhonenumberInput",

  props: {
    value: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      number: "",
      phoneNumberValid: true,
    };
  },

  computed: {
    ...mapState("configuration", ["darkmode"]),
  },

  methods: {
    phoneValidation(val) {
      this.phoneNumberValid = this.number == "" || val.isValid;
    },
  },

  watch: {
    value(val) {
      if (val[0] == "4") this.number = val.substring(2);
      if (val[0] == "+") this.number = val.substring(3);
      else this.number = val;

      this.number = this.number.replace("-", "").replace(" ", "");
    },

    number(val) {
      if (val == null || val == "") this.number = "";

      if (val != null && val.length > 0 && val[0] == "0")
        this.number = val.substring(1);

      this.number.replace("-", "").replace(" ", "");
      this.$emit("input", this.number);
      this.$emit(
        "validation",
        this.number == "" ? true : this.phoneNumberValid
      );
    },
  },
};
</script>